export default "__VITE_ASSET__e1bbd27f__"